import {Page, Text, View, Document, StyleSheet, Image} from '@react-pdf/renderer'
import {InvoiceData} from '../core/_model'
import {isReddata} from '../../../utils/helperFunction/_helper'

const styles = StyleSheet.create({
  page: {padding: 50, fontSize: 10},

  title: {
    textAlign: 'center',
    marginVertical: 10,
    fontSize: 14,
    fontWeight: 'bold',
  },

  rowBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between', // put space between left & right columns
    alignItems: 'flex-start', // keep both columns top-aligned
    marginBottom: 8,
  },

  column: {
    width: '70%',
  },

  column2: {
    width: '48%',
    alignSelf: 'flex-end', // ✅ Works
    // textAlign: "right",
  },

  columnRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },

  label: {
    width: 100, // ✅ fixed width works in PDF
  },

  value: {
    flex: 1,
  },

  columnTextStart: {
    width: 140,
    color: 'red',
  },

  tableHeader: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    borderTop: '1px solid black',
    padding: 5,
    fontWeight: 'bold',
  },

  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    padding: 5,
  },

  cell: {width: '14%', textAlign: 'center'},
  desc: {width: '30%'},

  box: {
    // border: "1px solid black",
    // padding: 5,
    width: '50%',
  },

  bottomHeader: {
    fontWeight: 'bold',
    borderBottom: '1px solid black',
    paddingBottom: 3,
    marginBottom: 3,
    textAlign: 'center',
  },

  bottomHeader2: {
    fontWeight: 'bold',
    borderBottom: '1px solid black',
    paddingBottom: 3,
    marginBottom: 3,
  },

  footer: {
    marginTop: 80,
    borderTop: '1px solid black',
    paddingTop: 10,
    textAlign: 'center',
  },
})

const deparmentStyle = StyleSheet.create({
  tableContainer: {
    border: '1px solid black',
    width: '50%',
  },

  tableTitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 12,
    padding: 4,
    borderBottom: '1px solid black',
  },

  tableHeader: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
  },

  tableHeaderCell: {
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 2,
    // borderRight: "1px solid black",
  },

  tableHeaderCellLast: {
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 2,
  },

  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
  },

  tableCell: {
    flex: 1,
    padding: 2,
    textAlign: 'center',
    // borderRight: "1px solid black",
  },

  tableCellLast: {
    flex: 1,
    padding: 4,
    textAlign: 'center',
  },
})

const pathurl = isReddata() ? '/media/logos/reddata-logo.png' : '/media/logos/iatl-logo.png'

const CorporateInvoice = ({data}: {data: InvoiceData}) => {
  const subTotal = data.items.reduce((sum, i) => sum + i.quantity * i.unitPrice, 0)

  const vat = (subTotal * data.vatRate) / 100
  const grandTotal = subTotal + vat

  console.log(pathurl)

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        {/* LOGO */}
        {/* <Text style={styles.logo}>RedData</Text>
         */}
        <Image
          src={pathurl}
          style={{
            width: 155, // desired width in PDF units
            height: 35, // desired height
            objectFit: 'contain',
          }}
        />

        {/* TITLE */}
        <Text style={styles.title}>INVOICE</Text>

        {/* CUSTOMER & PROVIDER */}
        <View style={styles.rowBetween}>
          <View style={styles.column}>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Customer Name</Text>
              <Text style={styles.value}>: {data.customerName}</Text>
            </View>

            <View style={styles.columnRow}>
              <Text style={styles.label}>Customer BIN</Text>
              <Text style={styles.value}>: {data.customerBIN}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Address</Text>
              <Text style={styles.value}>: {data.address}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Attention</Text>
              <Text style={styles.value}>: {data.attention}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Customer No</Text>
              <Text style={styles.value}>: {data.customerNo}</Text>
            </View>
          </View>

          <View style={styles.column2}>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Service Provider</Text>
              <Text style={styles.value}>: {data.providerName}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Company BIN</Text>
              <Text style={styles.value}>: {data.providerBIN}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Address</Text>
              <Text style={styles.value}>: {data.providerAddress}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Invoice No</Text>
              <Text style={styles.value}>: {data.invoiceNo}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Mushok 6.3 No</Text>
              <Text style={styles.value}>: {data.mushokNo}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Issue Date</Text>
              <Text style={styles.value}>: {data.issueDate}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Last Date Payment</Text>
              <Text style={styles.value}>: {data.lastPaymentDate}</Text>
            </View>
            <View style={styles.columnRow}>
              <Text style={styles.label}>Billing Period</Text>
              <Text style={styles.value}>: {data.billingPeriod}</Text>
            </View>
          </View>
        </View>

        {/* TABLE */}
        <View style={{marginTop: 10}}>
          <View style={styles.tableHeader}>
            <Text style={styles.cell}>SL</Text>
            <Text style={styles.desc}>Descriptions</Text>
            <Text style={styles.cell}>Qty</Text>
            <Text style={styles.cell}>Unit</Text>
            <Text style={styles.cell}>Total</Text>
            <Text style={styles.cell}>VAT</Text>
            <Text style={styles.cell}>Total + VAT</Text>
          </View>

          {data.items.map((item) => {
            const total = item.quantity * item.unitPrice
            const vatAmount = (total * data.vatRate) / 100

            return (
              <View key={item.sl} style={styles.tableRow}>
                <Text style={styles.cell}>{item.sl}</Text>
                <Text style={styles.desc}>{item.description}</Text>
                <Text style={styles.cell}>{item.quantity}</Text>
                <Text style={styles.cell}>{item.unitPrice}</Text>
                <Text style={styles.cell}>{total.toFixed(2)}</Text>
                <Text style={styles.cell}>{vatAmount.toFixed(2)}</Text>
                <Text style={styles.cell}>{(total + vatAmount).toFixed(2)}</Text>
              </View>
            )
          })}
        </View>

        {/* TOTAL */}
        <View style={{marginTop: 10}}></View>
        <View style={styles.columnRow}>
          <Text style={styles.label}>Amount in Word </Text>
          <Text style={styles.value}>: Taka {grandTotal.toFixed(2)} Only</Text>
        </View>

        {/* SIGNATURE */}
        <View style={styles.columnRow}>
          <Text style={styles.label}>Authorised Person</Text>
          <Text style={styles.value}>: {data.authorizedPerson}</Text>
        </View>
        <View style={styles.columnRow}>
          <Text style={styles.label}>Designaiton</Text>
          <Text style={styles.value}>: {data.designation}</Text>
        </View>
        <View style={styles.columnRow}>
          <Text style={styles.label}>Signature</Text>
          <Text style={styles.value}>:</Text>
        </View>

        {/* BOTTOM BOXES */}
        <View style={[styles.rowBetween, {marginTop: 20, gap: 10}]}>
          <View style={{width: '40%', border: '1px solid black'}}>
            <Text style={styles.bottomHeader}>Bank Information</Text>
            <Text
              style={{
                paddingVertical: 2,
                paddingLeft: 2,
                borderBottom: '1px solid black',
              }}
            >
              Account Name : RED DATA
            </Text>
            <Text
              style={{
                paddingVertical: 2,
                paddingLeft: 2,
                borderBottom: '1px solid black',
              }}
            >
              Bank : City Bank PLC
            </Text>
            <Text
              style={{
                paddingVertical: 2,
                paddingLeft: 2,
                borderBottom: '1px solid black',
              }}
            >
              Branch : Gulshan
            </Text>
            <Text
              style={{
                paddingVertical: 2,
                paddingLeft: 2,
              }}
            >
              Routing : 225261733
            </Text>
          </View>

          {/* <View style={styles.box}>
            <Text style={styles.bottomHeader}>Billing & Payment Contact</Text>
          </View> */}

          <View style={deparmentStyle.tableContainer}>
            {/* Table Title */}
            <Text style={styles.bottomHeader}>Billing & Payment Contact</Text>

            {/* Table Header */}
            <View style={deparmentStyle.tableHeader}>
              <Text style={deparmentStyle.tableHeaderCell}>Department</Text>
              <Text style={deparmentStyle.tableHeaderCell}>Name</Text>
              <Text style={deparmentStyle.tableHeaderCellLast}>Phone</Text>
            </View>

            {/* Table Rows */}
            {data.contact.map((row, index) => (
              <View key={index} style={deparmentStyle.tableRow}>
                <Text style={deparmentStyle.tableCell}>{row.deparment}</Text>
                <Text style={deparmentStyle.tableCell}>{row.name}</Text>
                <Text style={deparmentStyle.tableCellLast}>{row.phone}</Text>
              </View>
            ))}
          </View>
        </View>
        <View style={{width: '50%', marginTop: 50}}>
          <Text style={styles.bottomHeader2}>Received By</Text>
          <Text style={{paddingVertical: 2}}>Name:</Text>
          <Text style={{paddingVertical: 2}}>Designation:</Text>
          <Text style={{paddingVertical: 2}}>Date:</Text>
          <Text style={{paddingVertical: 2}}>Signature:</Text>
        </View>

        {/* FOOTER */}
        <View style={styles.footer}>
          <Text>Red Data (Pvt.) Limited</Text>
          <Text>134 Gulshan Avenue, Dhaka 1212</Text>
          <Text>+880 9640 123 123 | info@reddata.com.bd</Text>
        </View>
      </Page>
    </Document>
  )
}

export default CorporateInvoice
